


















import Vue, { PropType } from 'vue'
import { Multimedia } from '@/model/Multimedia'

export default Vue.extend({
  name: 'Multimedia',
  props: {
    multimedia: {
      type: Object as PropType<Multimedia>,
    },
    width: {
      type: [String, Number],
    },
    height: {
      type: [String, Number],
    },
    maxWidth: {
      type: [String, Number],
    },
    maxHeight: {
      type: [String, Number],
    },
    aspectRatio: {
      type: [String, Number],
    },
    size: {
      type: String,
      default: 'size4',
    },
    contain: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    position: function (): string {
      if (!this.multimedia) {
        return 'center center'
      }

      if (this.multimedia.coordinates === '') {
        return 'center center'
      }

      return this.multimedia.coordinates
    },
  },
  data: () => ({}),
})
